module.exports = __webpack_public_path__ + "img/pencil-outline.9036cf39.svg";